import React, {useEffect, useState} from 'react'
import './_video.scss'
import {AiFillEye} from 'react-icons/ai'
import request from '../../axios'
import moment from 'moment';
import numeral from 'numeral';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useHistory } from 'react-router';

const Video = ({video}) => {

    const {
        id,
        snippet: {
           channelId,
           channelTitle,
           title,
           publishedAt,
           thumbnails: { medium },
        },
        contentDetails,
     } = video


     const [views,setViews] = useState(null);
     const [duration, setDuration] = useState(null);
     const [channelIcon, setChannelIcon] = useState(null);

     const _videoId = id?.videoId || id;
 

    useEffect(() => {
        const get_video_details = async () => {
            const {data:{items}} = await request("/videos", {
                params: {
                    part: "contentDetails, statistics",
                    id: _videoId
                }
            })
            console.log(items);
            //# items:{contentDetails: {duration,...}, statistics: {commentCount, viewCount,..}}
            setViews(items[0].statistics.viewCount);
            setDuration(items[0].contentDetails.duration);
        }

        get_video_details();
  

    },[_videoId]);


    useEffect(() => {
        const get_channel_icon = async () => {
            const {data:{items}} = await request("/channels", {
                params: {
                    part: "snippet",
                    id: channelId
                }
            })
            console.log(items[0].snippet.thumbnails.default);
            //# items: {snippet: {thumbnails: {default, high, medium}}}
            setChannelIcon(items[0].snippet.thumbnails.default.url);
        }

        get_channel_icon();
    

    },[channelId]);

  
    const seconds = moment.duration(duration).asSeconds();
    const _duration = moment.utc(seconds * 1000).format("mm:ss");

    const history = useHistory();

    const handleVideoClick = () => {
        history.push(`/watch/${_videoId}`)
    }


    return (
        <div className="video" onClick={handleVideoClick}>
            <div className="video__top">
                {/* <img src={medium.url} alt=""/> */}
                <LazyLoadImage src={medium.url} effect="blur" />

                <span className="video__top__duration"> {_duration} </span>
            </div>
            <div className="video__title">
                {title}
            </div>
            <div className="video__details">
                <span>
                    <AiFillEye /> {numeral(views).format("0.a")} views • 
                </span>
                <span>{moment(publishedAt).fromNow()}</span>
            </div>
            <div className="video__channel">
                {/* <img src={channelIcon} alt=""/> */}
                <LazyLoadImage src={channelIcon && channelIcon} effect="blur" />
                <p> {channelTitle} </p>
            </div>
        </div>
    )
}

export default Video
